import { createFileRoute } from "@tanstack/react-router";
import { loadContentMeta, buildContentHead } from "@/lib/seo/contentHead";
import ContentPost from "@/pages/ContentPost";
const ContentPostRoute = () => <ContentPost contentType="white_papers" />;

export const Route = createFileRoute("/en/downloads/$slug")({
  loader: ({ params }) => loadContentMeta("white_papers", params.slug, "en"),
  head: ({ params, loaderData }) =>
    buildContentHead(`/en/downloads/${params.slug}`, loaderData),
  component: ContentPostRoute,
});

